import {
  ArrowRightFromBracketRegularIcon,
  BadgeCheckRegularIcon,
  BadgeCheckSolidIcon,
  CircleCheckSolidIcon,
  DhisLogo,
} from "@elixir/icons";
import { InputField, PrimaryButton, SecondaryButton } from "ui";
import useHprHfrOnboardingStore from "../../../stores/hpr-hfr-dhis-onboarding";

const HfrCreatedSuccessfully = () => {
  const hfrFacilityId = useHprHfrOnboardingStore(
    (state) => state.hfrFacilityId
  );
  const isExistingHfrOnboarding = useHprHfrOnboardingStore(
    (state) => state.isExistingHfrOnboarding
  );
  return (
    <div className="dr-h-full dr-flex dr-flex-col">
      <div className="dr-flex dr-p-48"></div>
      <div className="dr-w-full dr-flex-1 dr-flex dr-flex-col dr-items-center dr-justify-center dr-space-y-12">
        <BadgeCheckSolidIcon className="dr-w-40 dr-h-40 dr-text-darwin-touch-green-primary" />
        <div className="TouchTitle1Bold dr-text-darwin-touch-neutral-1000 dr-text-center">
          {isExistingHfrOnboarding
            ? "Your HFR was successfully onboarded onto eka"
            : "Your HFR ID was created successfully"}
        </div>
        <div className="dr-flex dr-items-center dr-justify-center dr-rounded-8 dr-bg-darwin-touch-green-bg-light dr-p-12 dr-space-x-12 dr-min-w-310">
          <div className="dr-w-32 dr-h-32 dr-min-w-32 dr-p-6 dr-rounded-full dr-bg-darwin-touch-neutral-0 dr-items-center dr-flex dr-justify-center">
            <DhisLogo />
          </div>
          <div className="HeadlineBold dr-text-darwin-touch-neutral-1000">
            {hfrFacilityId}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HfrCreatedSuccessfully;
